import React from 'react';

const IconFullScreen = () => {
  return (
    <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Full screen</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g>
          <polygon points="1,0 0,0 0,10 4,10 4,4 10,4 10,0 4,0"/>
        </g>
        <g>
          <polygon points="4,16 0,16 0,22 0,25 0,26 10,26 10,22 4,22"/>
        </g>
        <g>
          <polygon points="22,22 16,22 16,26 22,26 25,26 26,26 26,16 22,16"/>
        </g>
        <g>
          <polygon points="16,0 16,4 22,4 22,10 26,10 26,4 26,1 26,0"/>
        </g>
      </g>
    </svg>
  );
};

export default IconFullScreen;